import type { SupportFormSchema } from '@/modules/support/components/SupportForm/SupportForm.types'

export const supportFormDefaultValues: SupportFormSchema = {
  accountId: null,
  message: '',
  subject: '',
  transactionId: null,
}

export const SUPPORT_SUBJECT_OPTIONS = [
  { label: 'Account issue', value: 'Account issue' },
  { label: 'Transaction issue', value: 'Transaction issue' },
  { label: 'Bug report', value: 'Bug report' },
  { label: 'Feature request', value: 'Feature request' },
  { label: 'General question', value: 'General question' },
  { label: 'Other', value: 'Other' },
]
